module.exports = __webpack_public_path__ + "static/media/one-in-three-installation.0698f038.jpg";